module.exports = __webpack_public_path__ + "img/shank buttons quantity.f0e09c9d.png";